import { useState } from 'react';
import Header from '../components/Header.tsx';
import Sidebar from '../components/Sidebar.tsx';
import './Profile.css';
import useAuth from '../hooks/useAuth.ts';
import { sidebarOpenForViewport } from '../context/SidebarProvider.tsx';

function Profile() {
  const { name: userName, email: userEmail, roles } = useAuth();
  const [showSidebar, setShowSidebar] = useState(sidebarOpenForViewport);

  const getInitials = (name: string | null) => {
    if (!name) return 'U';
    const nameParts = name.trim().split(' ');
    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }
    const firstInitial = nameParts[0].charAt(0).toUpperCase();
    const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
    return firstInitial + lastInitial;
  };

  return (
    <section className="section">
      <div className="profile">
        <Header title="My Profile" setShowSidebar={setShowSidebar} showSidebar={showSidebar} />
        <div className="container">
          <div
            className="sidebarStyle app-sidebar-rail"
            style={{
              width: showSidebar ? '224px' : '56px',
              transition: 'width 0.3s',
            }}
          >
            <Sidebar />
          </div>
          <div className="mainContentStyle">
            <div className="profileContent">
              <div className="profileHeader">
                <div className="profileAvatar">
                  {getInitials(userName)}
                </div>
                <h2 className="profileTitle">Profile Information</h2>
                <p className="profileSubtitle">Your account details and settings</p>
              </div>
              
              <div className="profileFields">
                <div className="profileField">
                  <span className="profileLabel">Full name</span>
                  <span className="profileValue">{userName || 'name'}</span>
                </div>
                <div className="profileField">
                  <span className="profileLabel">Email</span>
                  <span className="profileValue">{userEmail || 'email'}</span>
                </div>
                <div className="profileField">
                  <span className="profileLabel">Role</span>
                  <span className="profileValue">{roles && roles.length > 0 ? roles.join(', ') : 'No role assigned'}</span>
                </div>
              </div>
              
              <div className="authNotice">
                <p className="authNoticeText">
                  <strong>Authentication:</strong> Microsoft Azure AD
                </p>
                <p className="authNoticeText">
                  To change your password or manage account settings, please use your organization's Microsoft account portal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Profile;
